<template lang="pug">
    Tabs.article-list
        el-card.contains-table(shadow="always")
            .error(v-if="error")
                template(v-if="error.code")
                    Error(:message="$t(error.message || 'Something went wrong!')", :code="error.code")
                template(v-else)
                    Error(:message="$t('Something went wrong!')", :code="501")
            .articles-table(v-else)
                //- :row-link-config="productsPaginated.link"
                paginated-items(
                    :scope="scope"
                    :type="key"
                    :loading="loading"
                    :items="articlesPaginated.items"
                    :filters="filters"
                    :show-filters="showFilters"
                    :variables="articlesPaginated.variables"
                    :all-columns="articlesPaginated.allColumns"
                    :active-columns="activeColumns"
                    :page-info="articlesPaginated.pageInfo"
                    :sort="sort"
                    @pagination-size-change="changePaginationSize"
                    @pagination-current-change="changeCurrentPage"
                    @show-table-columns="changeTableColumns"
                    @change-filter="changeFilter"
                    @click="openModal"
                    @change-sort="handleSortInputChange"
                )
                    template(slot="top")
                        el-row.table-top(v-loading="loading" type="flex" justify="space-between")
                            .left
                            .right.hide-on-empty
                                //- span {{ $t('Selected Products') }}:
                                //- el-select(v-model="selectAction" size="mini" placeholder="Aktion" disabled)
                                //-     el-option(v-for="item in optionAction" :key="item.value" :label="item.label" :value="item.value")
                                //- el-button(type="primary" size="mini" disabled) {{ $t('Go') }}
                                el-button(
                                    plain
                                    size="mini"
                                    type="primary"
                                    icon="el-icon-fa-filter fas"
                                    @click="toggleFilterVisiblity"
                                    :disabled="disable.showFilters || hasFilters"
                                )
                                    span(v-if="showFilters") {{ $t('Hide filters') }}
                                    span(v-else) {{ $t('Show filters') }}
                    template(v-slot:info-before:th)
                        span {{ $t('Product') }}
                    template(v-slot:info-before:filter)
                        pagination-filter(
                            name="query"
                            type="SingleInput"
                            :values="filters['query']"
                            @change="changeFilter"
                        )
                    template(v-slot:info-before="{ item }")
                        el-button(
                            v-if="item.product"
                            type="text"
                            icon="el-icon-fa-arrow-right fas"
                            @click.stop.prevent="redirectToProduct(item.product)"
                        )
                            span(v-if="item.product.nr != item.product.name")
                                | {{ (item.product.nr + ' / ' + item.product.name) | truncate(50) }}
                            span(v-else) {{ item.product.nr }}

                    template(v-slot:status="{ value }")
                        span {{ $t(value) }}

                    template(v-slot:name="{ value, item }")
                        template(v-if="value") {{ value }}
                        span.gray(v-else) {{ item.product.name }}

                    template(v-slot:properties="{ value: propertyPivots }")
                        span(v-if="propertyPivots && propertyPivots.length")
                            property-pivot-values(
                                v-for="propertyPivot in propertyPivots"
                                :key="propertyPivot.id"
                                :property="propertyPivot.property"
                                :value-options="[propertyPivot.valueOption]"
                            )
                        small.gray(v-else)
                            i {{ $t('no properties') }}

                    template(v-slot:main_price_net="{ value, item }")
                        span(v-if="value") {{ value | moneyFormat(defaultCustomerGroupCurrency) }}
                        span.gray(v-else-if="item.price && item.price.net_value")
                            | {{ item.price.net_value | moneyFormat(defaultCustomerGroupCurrency) }}
                    template(v-slot:main_price_gross="{ value, item }")
                        span(v-if="value") {{ value | moneyFormat(defaultCustomerGroupCurrency) }}
                        span.gray(v-else-if="item.price && item.price.gross_value")
                            | {{ item.price.gross_value | moneyFormat(defaultCustomerGroupCurrency) }}

                    template(v-slot:sell_through_rate="{ item }")
                        span {{ sellThroughRate(item) }}

                    template(v-slot:categories="{ item }")
                        .category-breadcrumbs
                            div(v-for="category in getItemCategories(item)" :key="category.id")
                                span {{ buildBreadcrumb(category) }}

                    template(v-slot:info-after:th)
                        span {{ $t('Update Stock') }}
                    template(v-slot:info-after:filter)
                        //- :values="selectedStock"
                        //- @change="(key, value) => selectedStock = value"
                        pagination-filter(
                            v-if="options.stock.items.length"
                            name="update-stock"
                            type="Select"
                            :options="options.stock.items.map(el => ({ value: el.id, label: el.name }))"
                            :values="{ key: 'update-stock', match: selectedStock ? selectedStock.id : undefined }"
                            @change="(key, { match: id }) => selectedStock = options.stock.items.find(el => el.id == id)"
                        )
                        span(v-else-if="options.stock.loading") {{ $t('no stock options') }}
                    template(v-slot:info-after="{ item }")
                        //- template(v-if="selectedStock")
                        //-     pre {{ getQty(item) }}
                        //-     pre {{ item.stocks.find(el => el.id == selectedStock.id) }}
                        el-input-number(
                            v-if="item.product.manage_stock && selectedStock"
                            :value="getQty(item)"
                            :min="0"
                            :disabled="savingArticleStocks.includes(`${item.id}:${selectedStock.id}`)"
                            @change="value => updateStock(item, value)"
                        )

        el-drawer(
            :title="$t('Article Form')"
            :visible.sync="modal.visibility"
            :before-close="confirmDiscard(() => changedSince(modal.formSnapshot, articleForm))"
            :wrapper-closable="false"
            :modal="true"
            size="90%"
            @closed="resetModal"
        )
            template(v-if="articleForm && articleRules")
                el-form.article-modal-form(
                    ref="form"
                    label-position="top"
                    :model="articleForm"
                    :rules="articleRules"
                    v-loading="ui.form.loading || !modal.productLoaded"

                    @submit.prevent.native="saveArticle"
                )
                    //- The article form works on its product (single-article rule, type, inherited
                    //- values), so it renders once that product is in the product store
                    ArticleForm(
                        v-if="modal.article && modal.productLoaded"
                        :article="modal.article"
                        :manage-stock="modal.article.product.manage_stock"
                    )
            .drawer-footer
                el-button(
                    round
                    size="mini"
                    icon="el-icon-fa-times fas"
                    @click="closeModal"
                ) {{ $t('Dismiss') }}
                el-button(
                    round
                    size="mini"
                    :disabled="ui.form.loading || ui.form.saving"
                    :loading="ui.form.saving"
                    type="primary"
                    icon="el-icon-fa-check fas"
                    @click="saveArticle"
                ) {{ $t('Save and close article') }}
</template>

<i18n>
{
    "de": {
        "Product": "Produkt",
        "Update Stock": "Bestand ändern",
        "Go": "Ausführen",
        "Selected Articles": "Markierte Artikel",
        "Show filters": "Filter anzeigen",
        "Hide filters": "Filter verbergen",
        "An error occurred!": "Es ist ein Fehler aufgetreten!",
        "Article could not be fetched.": "Artikel konnte nicht geladen werden.",
        "Article list could not be fetched.": "Artikelliste konnte nicht abgerufen werden.",
        "Article Form": "Artikelformular",
        "Save Article": "Artikel speichern",
        "Save and close article": "Artikel speichern und schließen",
        "Article could not be saved.": "Artikel konnte nicht gespeichert werden.",
        "Article saved successfully!": "Artikel erfolgreich gespeichert!",
        "no properties": "keine Attribute"
    }
}
</i18n>

<script>
import _ from 'lodash';

import { adminClient as apolloClient } from '@/store/apollo';
import pinia from '@/pinia';
import { useSetupStore, useShopArticleStore, useShopProductStore } from '@/stores';
import NestedSet from '@/nested-set-lib';

import StockApi from '@/extensions/shop/store/api/stock';
import ArticleApi from '@/extensions/shop/store/api/article';

import PaginatedItems from '@/components/PaginatedItems';
import PaginationFilter from '@/components/PaginationFilter';

import ArticleForm from '@/extensions/shop/views/Product/Form/Partials/ArticleForm';
import PropertyPivotValues from '@/extensions/shop/components/Products/PropertyPivotValues';
import Tabs from '@/extensions/shop/views/Partials/CatalogTabs';

import router from '@/router';
import discardGuard from '@/mixins/discardGuard';

export default {
    name: 'Articles',
    mixins: [discardGuard],
    data() {
        return {
            scope: 'ex',
            key: 'shop_product_article',
            error: false,
            disable: {
                showFilters: false
            },
            modal: {
                visibility: false,
                article: undefined,
                productLoaded: false,
                tab: 'main',
                formSnapshot: undefined,
            },
            selectedStock: undefined,
            savingArticleStocks: [],
        };
    },
    components: {
        PaginatedItems,
        PaginationFilter,
        ArticleForm,
        PropertyPivotValues,
        Tabs
    },
    watch: {
        'ui.form.loading': 'rememberArticleFormSnapshot',
        'articleForm.id': 'rememberArticleFormSnapshot',
    },
    computed: {
        shopArticleStore() {
            return useShopArticleStore(pinia);
        },
        activeColumns() {
            // return this.articlesPaginated.activeColumns.filter(el => {
            //     if (el.key === 'qty_sum' && this.manageStock === true) return el
            //     else if (el.key !== 'qty_sum') return el
            // })
            return this.articlesPaginated.activeColumns;
        },
        showFilters() {
            return this.hasFilters || _.get(this.articlesPaginated, 'showFilters') || false;
        },
        hasFilters() {
            return !_.isEmpty(this.filters);
        },
        filters() {
            let filters = _.cloneDeep(this.articlesPaginated.filters);
            delete filters.shop;
            delete filters.product;
            return filters;
        },

        sort() {
            var variables = this.articlesPaginated.variables;
            var defaultSort = this.articlesPaginated.defaultSort || { field: 'id', direction: 'desc' };
            var order = (variables.order !== undefined && variables.order !== '') ? variables.order : defaultSort.field;
            var direction = (variables.direction !== undefined && variables.direction !== '') ? variables.direction : defaultSort.direction;
            return { field: order, direction: direction };
        },

        activeShop() {
            return this.activeCms.shop;
        },
        loading() {
            return this.ui.articlesPaginated.loading;
        },

        defaultCustomerGroup() {
            return _.get(this.activeShop, 'defaultCustomerGroup');
        },
        defaultCustomerGroupCurrency() {
            const code = _.get(this.activeShop, 'defaultCustomerGroup.currency.iso4217');
            return code || 'EUR';
        },

        setupStore() {
            return useSetupStore(pinia);
        },
        activeCms() {
            return this.setupStore.activeCms;
        },
        enabledExtensions() {
            return this.setupStore.enabledExtensions;
        },
        options() {
            return this.shopArticleStore.options;
        },
        articleForm() {
            return this.shopArticleStore.form;
        },
        articleRules() {
            return this.shopArticleStore.rules;
        },
        articlesPaginated() {
            return this.shopArticleStore.articlesPaginated;
        },
        ui() {
            return this.shopArticleStore.ui;
        },
        categoryFilterOptions() {
            const column = (this.articlesPaginated.allColumns || []).find(c => c.key === 'categories');
            const options = _.get(column, 'filter.options') || [];
            return options.map(option => ({ id: option.value, name: option.label, _lft: option._lft, _rgt: option._rgt, depth: option.depth }));
        },
    },
    methods: {
        // initialize() {
        //     if (! this.enabledExtensions.includes('shop')) {
        //         this.updateLoading(true)
        //         return
        //     }

        //     this.updateLoading(true)
        //     this.refetch()
        // },
        getItemCategories(item) {
            return _.get(item, 'product.categories') || [];
        },
        sellThroughRate(item) {
            const stock = Number(item.qty_sum) || 0;
            const sold = Number(item.sold_qty_sum) || 0;
            const base = stock + sold;
            if (base <= 0) return '–';
            return `${Math.round((sold / base) * 100)}%`;
        },
        buildBreadcrumb(category) {
            const fullCategory = this.categoryFilterOptions.find(opt => opt.id === Number(category.id)) || category;
            const ancestors = NestedSet.getAncestors(this.categoryFilterOptions, fullCategory);
            return [...ancestors.map(ancestor => ancestor.name), fullCategory.name || category.name].join(' > ');
        },
        // eslint-disable-next-line
        getQty(item) {
            let qty

            const stocks = item.stocks || []
            const stock = stocks.find(el => el.id === this.selectedStock.id)
            if (stock) qty = stock.pivot.qty || 0

            return qty;
        },
        updateStock(article, qty) {
            this.updatePaginatedArticleQty({ article, stock: this.selectedStock, qty })
            this.debouncedUpdateStock(article, qty)
        },
        debouncedUpdateStock: _.debounce(function (article, qty) {
            const stock = _.cloneDeep(this.selectedStock)
            const key = `${article.id}:${stock.id}`
            if (!this.savingArticleStocks.includes(key)) {
                this.savingArticleStocks.push(key)
            }

            const payload = {
                id: stock.id,
                articles: [
                    {
                        id: article.id,
                        pivot: { qty }
                    }
                ]
            }

            return StockApi.update(payload)
                .then((stock) => {
                    // success message
                    ArticleApi.fetchArticle(article.id, this.activeShop.id)
                        .then(article => {
                            this.replacePaginatedArticle(article)
                        });
                })
                .catch((err) => {
                    // error message
                })
                .finally(() => {
                    this.savingArticleStocks = this.savingArticleStocks.filter(el => el !== key)
                })

        }, useSetupStore(pinia).debounce || 300),
        handleClick(item) {
            // const params = { id: item.id }
            // router.push({ name: 'product-main', params })
        },
        handleSortInputChange(key, value) {
            this.defineSort({ key, value });
            this.refetch();
        },
        redirectToProduct(product) {
            const params = { id: product.id }
            router.push({ name: 'product-main', params })
        },
        changePaginationSize(itemsPerPage) {
            this.updateLoading(true);
            this.defineItemsPerPage(itemsPerPage);
            this.refetch();
        },
        changeCurrentPage(currentPage) {
            this.updateLoading(true);
            this.defineCurrentPage(currentPage);
            this.refetch();
        },
        changeTableColumns(visibleColumns) {
            this.defineActiveColumns(visibleColumns);
            // apolloClient.cache.reset()
            apolloClient.clearStore();
        },
        changeFilter(key, value, debounce = true) {
            this.defineCurrentPage(1);
            this.defineFilterValue({ key, value });
            if (debounce) this.debouncedRefetch();
            else this.refetch();
        },
        toggleFilterVisiblity() {
            const visible = this.showFilters;

            let value = false;
            if (!visible) value = true;

            this.disable.showFilters = true;
            this.defineFilterVisibility(value);
            // this.saveFilterVisibility({ scope: 'cp', key: this.key, value })
            this.saveFilterVisibility({ scope: this.scope, key: this.key, value })
                .finally(() => this.disable.showFilters = false);
        },
        refetch() {
            // set shop filter
            if (this.activeShop) {
                const key = 'shop';
                const value = {
                    key,
                    match: this.activeShop.id,
                    like: '',
                    from: '',
                    to: '',
                    in: []
                };
                this.defineFilterValue({ key, value });
            }

            this.updateLoading(true);
            this.fetchArticlesPaginated({ scope: this.scope, type: this.key })
                .then(() => this.updateLoading(false))
                .catch(err => {
                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);
                    this.updateLoading(false);

                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Article list could not be fetched.'),
                        iconClass: 'fas el-icon-fa-xmark',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                });
        },

        debouncedRefetch: _.debounce(function () {
            // function scope is needed here
            this.updateLoading(true);
            this.refetch();
        }, useSetupStore(pinia).debounce || 300),

        openModal(article) {
            this.modal.article = article;
            this.modal.productLoaded = false;
            this.modal.visibility = true;

            useShopProductStore(pinia).fetchProduct(article.product.id)
                .then(() => {
                    this.modal.productLoaded = true;
                })
                .catch(err => {
                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);
                    this.closeModal();
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Article could not be fetched.'),
                        iconClass: 'fas el-icon-fa-xmark',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                });
        },

        // The drawer counts as untouched until the article it was opened for has arrived; the
        // snapshot taken then is what Escape compares against.
        rememberArticleFormSnapshot() {
            const loaded = this.modal.visibility
                && !this.ui.form.loading
                && this.modal.article
                && String(this.articleForm.id) === String(this.modal.article.id);
            this.$nextTick(() => {
                this.modal.formSnapshot = loaded ? this.snapshotOf(this.articleForm) : undefined;
            });
        },
        closeModal() {
            this.modal.visibility = false;
        },
        resetModal() {
            this.modal = {
                article: undefined,
                productLoaded: false,
                visibility: false,
            };
            useShopProductStore(pinia).reset();

            // this.resetArticleUI();
            this.resetArticleForm();
            // this.$nextTick(this.resetArticleRules);
        },

        saveArticle() {
            // eslint-disable-next-line
            this.$refs.form.validate((valid, errors) => {
                // console.log('valid', valid, errors);

                if (valid) {
                    this.updateSaving(true);

                    this.update(this.articleForm)
                        .then(() => {
                            this.refetch();
                            this.closeModal();
                            this.updateSaving(false);
                            this.$notify.success({
                                title: this.$t('Article saved successfully!'),
                                iconClass: 'fas el-icon-fa-check',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });
                        })
                        .catch(err => {
                            /* eslint no-console: ["error", { allow: ["error"] }] */
                            console.error(err);
                            this.updateSaving(false);
                            this.$notify.error({
                                title: this.$t('An error occurred!'),
                                message: this.$t('Article could not be saved.'),
                                iconClass: 'fas el-icon-fa-xmark',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });
                        });
                } else {
                    // check the invalid fields
                    // and go to the corresponding tab
                    // or open the corresponding closed area
                    // TODO: scroll to invalid field
                    // let invalidTabs = [];
                    // _.each(errors, (error, path) => {
                    //     if (_.indexOf(['nr', 'status', 'name', 'categories', 'media'], path) >= 0) {
                    //         invalidTabs.push('main');
                    //     }
                    //     if (_.startsWith(path, 'prices.')) {
                    //         invalidTabs.push('prices');
                    //     }
                    //     // TODO: stock
                    // });
                    // invalidTabs = _.uniq(invalidTabs);

                    this.$notify.warning({
                        title: this.$t('Form is not valid!'),
                        message: this.$t('Correct your input and submit again.'),
                        iconClass: 'fas el-icon-fa-exclamation-circle',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                }
            });
        },

        fetchArticlesPaginated(payload) {
            return this.shopArticleStore.fetchArticlesPaginated(payload);
        },
        fetchStockOptions(shopId) {
            return this.shopArticleStore.fetchStockOptions(shopId);
        },
        saveFilterVisibility({ scope, key, value }) {
            return this.setupStore.saveFilterVisibility({ scope, key, value });
        },
        update(article) {
            return this.shopArticleStore.update(article);
        },
        resetArticleForm() {
            return this.shopArticleStore.reset();
        },
        resetArticleUI() {
            this.shopArticleStore.resetUI();
        },
        updateLoading(value) {
            this.shopArticleStore.updatePaginationLoading(value);
        },
        updateSaving(value) {
            this.shopArticleStore.updateFormSaving(value);
        },
        defineItemsPerPage(perPage) {
            this.shopArticleStore.defineItemsPerPage(perPage);
        },
        defineCurrentPage(currentPage) {
            this.shopArticleStore.defineCurrentPage(currentPage);
        },
        defineActiveColumns(columns) {
            this.shopArticleStore.defineActiveColumns(columns);
        },
        defineFilterValue(payload) {
            this.shopArticleStore.defineFilterValue(payload);
        },
        defineFilterVisibility(value) {
            this.shopArticleStore.defineFilterVisibility(value);
        },
        defineSort(payload) {
            this.shopArticleStore.defineSorting(payload);
        },
        updatePaginatedArticleQty(payload) {
            this.shopArticleStore.updatePaginatedArticleQty(payload);
        },
        replacePaginatedArticle(article) {
            this.shopArticleStore.replacePaginatedArticle(article);
        }
    },
    mounted() {
        this.refetch();

        if (!this.options.stock.items.length) {
            this.fetchStockOptions(this.activeShop.id)
                // .then(() => {
                //     if (this.options.stock.items.length) {
                //         this.selectedStock = this.options.stock.items[0];
                //     }
                // })
        }
    }
};
</script>

<style lang="sass" scoped>
.paginated-items
    // :not(.hover)

    :deep()
        tr
            span.gray
                color: lighten($color-grey-text, 10%)

.el-alert + .el-alert
    margin-top: 10px

section
    padding: 20px

.articles-tab :deep() .el-drawer .el-drawer__body
    overflow-x: hidden
</style>
